import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "aa_admin_token";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Resolve relative image paths (e.g. /api/images/..) against the backend URL
export const resolveImageUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  return res.data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/upload`, formData, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const fetchProducts = async (params = {}) => {
  const res = await axios.get(`${API}/products`, { params });
  return res.data;
};

export const fetchProduct = async (id) => {
  const res = await axios.get(`${API}/products/${id}`);
  return res.data;
};

export const createProduct = async (payload) => {
  const res = await axios.post(`${API}/products`, payload, { headers: authHeaders() });
  return res.data;
};

export const updateProduct = async (id, payload) => {
  const res = await axios.put(`${API}/products/${id}`, payload, { headers: authHeaders() });
  return res.data;
};

export const deleteProduct = async (id) => {
  const res = await axios.delete(`${API}/products/${id}`, { headers: authHeaders() });
  return res.data;
};

export const submitEnquiry = async (payload) => {
  const res = await axios.post(`${API}/enquiries`, payload);
  return res.data;
};

export const fetchEnquiries = async () => {
  const res = await axios.get(`${API}/enquiries`, { headers: authHeaders() });
  return res.data;
};

export const deleteEnquiry = async (id) => {
  const res = await axios.delete(`${API}/enquiries/${id}`, { headers: authHeaders() });
  return res.data;
};

export const bulkDeleteEnquiries = async (ids) => {
  const res = await axios.post(`${API}/enquiries/bulk-delete`, { ids }, { headers: authHeaders() });
  return res.data;
};
